import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
export function useStudioItem() {
    const { t } = useTranslation();
    const isEclipseSubmitStudioFlagEnabled = useFlag('eclipse_submit_studio');
    if (!isEclipseSubmitStudioFlagEnabled) {
        return null;
    }
    const linkUrl = Url.submitStudio();
    return {
        label: t('siteHeader.userMenu.myStudio'),
        link: linkUrl,
        biData: BiData({
            evid: 702,
            link_url: linkUrl,
            menu_item: 'my_studio',
            menu_name: 'profile'
        })
    };
}
